<template>
  <div>
    <CobroFacturasCE v-if="model.cobroexpress"></CobroFacturasCE>

    <CobroFacturasRP v-if="model.rapipago"></CobroFacturasRP>
  </div>
</template>

<style>
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

import KitsCombo from "@/components/KitsCombo";
import CobroFacturasCE from "@/views/CobroFacturasCE";
import CobroFacturasRP from "@/views/CobroFacturasRP";

export default {
  components: {CobroFacturasCE,CobroFacturasRP},
  data() {
    return {
      model: { rapipago: false, cobroexpress: false }
    };
  },
  methods: {
    cargar() {
      let context = this;
      axiosHelpers.axiosGet(
        "Article/GetOperatorActiveCobroFactura",
        {},
        this,
        function(data) {
          context.model.rapipago = data.ResponseVM.IsRapiPago;
          context.model.cobroexpress = !data.ResponseVM.IsRapiPago;
        }
      );
    }
  },
  beforeMount: function() {
    this.cargar();
  }
};
</script>